import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Компонент перебрасывает пользователя вверх страницы при каждой смене URL.
export function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
}
